import React from "react";
import cn from "classnames";
import styles from "./DualButton.module.sass";

const DualButton = ({
  label,
  option1,
  option2,
  value,
  onChange,
  multiSelect = false,
  className,
  tooltip
}) => {
  const handleOptionClick = (option) => {
    if (multiSelect) {
      // Mode multi-sélection : toggle l'option
      if (Array.isArray(value)) {
        const newValue = value.includes(option)
          ? value.filter(v => v !== option)
          : [...value, option];
        onChange(newValue);
      } else {
        // Si value n'est pas un array, on commence avec l'option cliquée
        onChange([option]);
      }
    } else {
      // Mode sélection simple : remplace la valeur
      onChange(option);
    }
  };

  const isActive = (option) => {
    if (multiSelect) {
      return Array.isArray(value) && value.includes(option);
    } else {
      return value === option;
    }
  };

  return (
    <div className={cn(styles.field, className)}>
      {label && (
        <div className={styles.label}>
          {label}
        </div>
      )}
      <div className={styles.dualButton}>
        <button
          className={cn(styles.optionButton, {
            [styles.active]: isActive(option1)
          })}
          onClick={() => handleOptionClick(option1)}
          type="button"
        >
          {option1}
        </button>
        <button
          className={cn(styles.optionButton, {
            [styles.active]: isActive(option2)
          })}
          onClick={() => handleOptionClick(option2)}
          type="button"
        >
          {option2}
        </button>
      </div>
      {multiSelect && (
        <div className={styles.hint}>
          Vous pouvez sélectionner une ou plusieurs options
        </div>
      )}
    </div>
  );
};

export default DualButton;
